"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantType = 'constant';
exports.isConstantCalculation = function (calc) {
    return calc !== undefined && calc.type === exports.ConstantType;
};
exports.constantColumnTransformCreator = function (definition, name) {
    var column = definition.schema[name];
    if (!exports.isConstantCalculation(column.calculation)) {
        throw new Error("Could not resolve constant calculation with name: " + name);
    }
    return constantColumnTransform(name, column.calculation.value);
};
var constantColumnTransform = function (name, value) {
    return function (sourceTable, previousStep) {
        return previousStep.map(function (record) {
            var newRecord = __assign({}, record);
            newRecord[name] = value;
            return newRecord;
        });
    };
};
//# sourceMappingURL=ConstantCalculation.js.map